import React, { FC } from 'react';
import { FooterContainer } from '../modules/footer/footer.container';
import { SiteMapContainer } from '../modules/site-map/site-map.container';

export const SiteMap: FC = () => {
  return (
    <>
      <div>
        <SiteMapContainer />
      </div>
      <FooterContainer />
    </>
  );
};
